import React from 'react'

import { Header } from 'Header'
import Helmet from 'react-helmet'

import css from './CheckoutLayout.css'

export function CheckoutLayout({ children }: React.PropsWithChildren<Record<string, never>>) {
  return (
    <span>
      <Helmet
        title="Food Boxes | Get Fresh Food &amp; Ingredients Delivered | Gousto"
        style={[
          {
            cssText: `
              #react-root {
                height: 100%;
              }
            `,
          },
        ]}
      />

      <div className={css.layoutContainer}>
        <div className={css.pageContainer}>
          <Header simple />
          {children}
        </div>
      </div>
    </span>
  )
}
